import { Alert, Box, Button, ButtonBase, ButtonGroup, Card, CardActionArea, CardActions, CardContent, Stack, Table, TableBody, TableCell, TableRow, Typography, makeStyles, tableCellClasses } from "@mui/material";
import { RobotDetailData, RobotMode } from "../types/Robot"
import { useEffect, useRef, useState } from "react";
import { TaskCollectionType, TaskRecordCollectionData } from "../types/TaskCollection";
import { TaskStatus } from "../types/Task";
import { useQueries, useQuery } from "react-query";
export const RobotCardRobotConfig = (props: {
    robotDetail: RobotDetailData,
    handleOnClick: (robotDetailData: RobotDetailData) => void,
    selected: boolean,
    isCharging: boolean,
    newRobotConfig: {[id: number]: undefined | string},
    setRobotConfig: (conf : {[id: number]: undefined | string}) => void,
    selectedLocation: string | undefined,
    taskRecordCollector: TaskRecordCollectionData | undefined

}) => {
    const { robotDetail, selected, handleOnClick, isCharging, newRobotConfig, setRobotConfig, taskRecordCollector} = props
    const {id, 
        name, 
        robotType, 
        image, 
        batteryStatus, 
        currentLocation, 
        robotState_str: robotState} = robotDetail;
    const getBatteryIcon = (batteryLevel: number) => {
        console.log(robotDetail)
        const battery = robotDetail.battery
        // console.log(robotState)
        return isCharging ? "./assets/charging.png"
            : battery > 80 ? "./assets/high-battery-level.png"
            : battery > 40 ? "./assets/medium-battery-level.png"
            : "./assets/low-battery-level.png"
    }

    const [changedConfig, setChangedConfig] = useState<boolean>(false)
    const [showCompartment, setShowCompartment] = useState<boolean>(false)

    const robotConfig = useRef<{[id: number]: undefined | string}>({})

    const hasConfig = () => {
        return (0 in robotConfig.current && robotConfig.current[0] !== undefined) || (1 in robotConfig.current && robotConfig.current[1] !== undefined)
    }

    const getConfigValue = (conf: {[id: number] : string | undefined}) => {
        return 0 in conf && conf[0] !== undefined 
                        ? conf[0]
                        : 1 in conf && conf[1] !== undefined
                        ? conf[1]
                        : undefined
    }

    // robotConfig.current = hasConfig() && getConfigValue(robotConfig.current) === getConfigValue(newRobotConfig) ? robotConfig.current : newRobotConfig

    const changeConfig = (id : number, value: string | undefined) => {
        if (value === "" || value === undefined || robotConfig.current[id] === value) {
            console.log("remove item")
            robotConfig.current[id] = undefined
        } else {
            robotConfig.current[id] = value
        }
        setRobotConfig(robotConfig.current)
        if (1 in robotConfig.current && robotConfig.current[1] === undefined &&
            0 in robotConfig.current && robotConfig.current[0] === undefined && showCompartment) {
            setShowCompartment(false)
        }
        // console.log(robotConfig.current)
    }

    useEffect(() => {
        if (changedConfig) {
            setChangedConfig(false)
        }
    }, [changedConfig])

    // useQuery("globalLatestTaskRecordCollector", async () => {
    //     const trc = await globalLatestLocationTaskCollections();
    //     setTaskRecordCollector(trc)
    // },
    // {
    //     refetchInterval: 1000
    // })

    return <>
    <Card sx={{
        width: 330,
        backgroundColor: (selected ? "#FFFFF9" : "#FFFFF9"),
        // borderRadius: "25px",
        marginBottom: "4px",
        height: "100%",
        // minHeight: "50%",
        // height: "inherit",
        }}>
      {/* <CardActionArea onClick={()=> {
        handleOnClick(robotDetail);
      }}> */}
      <Stack direction="row">
        <Stack sx={{
                justifyContent: "center",
                alignContent: "center",
                width: "80%"
            }}>
                <Typography sx={{
                    fontSize: "28px",
                    fontWeight:"bold",
                    padding: "12px"
                }}>{name}</Typography>
                <Box sx = {{
                    paddingLeft: "12px"
                }}>
                    <Alert 
                    severity={  robotDetail.robot_mode === RobotMode.MANUAL ? "error"
                                :taskRecordCollector ?
                                    taskRecordCollector.taskCollectionType === TaskCollectionType.CHARGING_JOB 
                                    ? "success"
                                    : taskRecordCollector.status === TaskStatus.ARRIVED 
                                    || taskRecordCollector.status === TaskStatus.IN_PROGRESS
                                    || taskRecordCollector.status === TaskStatus.QUEUED ? "warning"
                                    : taskRecordCollector.status === TaskStatus.COMPLETED ? "success"
                                    : "success"
                                : robotState === "Free"  ? "success" 
                                : robotState === "Busy"  ? "info"
                                : robotState === "Emergency Stop Pressed" ? "warning"
                                : "error"} sx={{
                        width: robotState === "Emergency Stop Pressed" ? "80%" : "70%",
                    }} variant="filled">
                        {  robotDetail.robot_mode === RobotMode.MANUAL ? "Robot not available"
                        : taskRecordCollector ?
                                    taskRecordCollector.taskCollectionType === TaskCollectionType.CHARGING_JOB 
                                    ? "Robot available"
                                    : taskRecordCollector.status === TaskStatus.ARRIVED 
                                    || taskRecordCollector.status === TaskStatus.IN_PROGRESS
                                    || taskRecordCollector.status === TaskStatus.QUEUED ? "Job in progress"
                                    : taskRecordCollector.status === TaskStatus.COMPLETED ? "Robot available"
                                    : "Robot available" 
                        : robotState === "Free"  ? "Robot available" 
                        : robotState === "Busy"  ? "Job in progress"
                        : robotState === "Emergency Stop Pressed" ? "Something happened to the robot!"
                        : "Robot stuck!"}</Alert>
                </Box>
        </Stack>
        <Stack direction="row" sx={{
            paddingTop: "18px",
            paddingRight: "12px",
        }}>
            <img src={getBatteryIcon(parseInt(batteryStatus))} alt="" height="28px"/>
            <Typography sx={{
                fontSize: "20px",
                paddingLeft: "12px"
            }}>
                {String(robotDetail.battery) + "%"}
            </Typography>
        </Stack>
      </Stack>
      <Box sx={{
            width:"100%",
            position: "relative"
        }}>
            <img src={showCompartment ? "./assets/robots/front_flashbot.png" : image} alt={String(id)}  style={{
                padding: "10%",
                objectFit: "contain",
                width: "70%",
                maxHeight: "280px",
            }}/>
            {showCompartment ? 
            <ButtonGroup orientation="vertical" aria-label="vertical outliuttned bon group" sx={{
                position: "absolute",
                left:"29%",
                right: "39.5%",
                top: "16%",
            }}>
                <Button key="one" onClick={() => {changeConfig(0, props.selectedLocation)}}  sx={{
                    height:"88px",
                    background: 0 in robotConfig.current && robotConfig.current[0] !== undefined? "#4472C4" : "#FAFAFA",
                    color: 0 in robotConfig.current && robotConfig.current[0] !== undefined? "#FAFAFA" : "#4472C4" ,
                    ":hover": {
                        background: "#FAFAFA",
                        color: "#4472C4"
                    }
                }}>{0 in robotConfig.current ? robotConfig.current[0] : ""}</Button>
                <Button key="two" onClick={() => {changeConfig(1, props.selectedLocation)}}  sx={{
                    height:"88px",
                    background: 1 in robotConfig.current && robotConfig.current[1] !== undefined ? "#4472C4" : "#FAFAFA",
                    color: 1 in robotConfig.current && robotConfig.current[1] !== undefined ? "#FAFAFA" : "#4472C4",
                    ":hover": {
                        background: "#FAFAFA",
                        color: "#4472C4"
                    }
                }}>{1 in robotConfig.current ? robotConfig.current[1] : ""}</Button>
            </ButtonGroup> : 
            <ButtonGroup orientation="vertical" aria-label="vertical outliuttned bon group" sx={{
                position: "absolute",
                left:"25%",
                right: "51.5%",
                top: "30%",
            }}>
                <Button onClick={()=>{setShowCompartment(true)}} sx={{
                    height:"88px",
                    background: "#4472C4",
                    color: "#FAFAFA",
                    ":hover": {
                        background: "#4472C4",
                        color: "#FAFAFA"
                    }
                }}> Add Payload</Button>
                </ButtonGroup>}
        </Box>
            
      {/* </CardActionArea> */}
    </Card>
    
    </>
}